import { FtpService } from "../domainObjects/dataConnector";

export class GetExcelSheetNamesRequest {
    fullPath: string;
    isUseFtp:boolean;
    ftpService: FtpService;

    constructor(path: string,isUseFtp:boolean,ftpService: FtpService) {
      this.fullPath = path;
      this.isUseFtp = isUseFtp;
      this.ftpService = ftpService;
    }
}
export class GetFeatherFileRequest {
  fullPath: string;

  constructor(path: string) {
    this.fullPath = path;
  }
  
}
export class GetParquetFileRequest {
  fullPath: string;

  constructor(path: string) {
    this.fullPath = path;
  }
  
}
